let config;

const oAuthRedirectUri = window.location.origin + "/";

switch (process.env.REACT_APP_DEPLOY_ENV) {
  case "prod":
    config = {
      cognito: {
        region: "us-east-1",
        userPoolId: "us-east-1_lGMZVYltr",
        userPoolWebClientId: "3cbusfei41th27vvf38ee8thgr"
      },
      oauthConfig: {
        domain:
          "member-center-serverless-frontend-prod.auth.us-east-1.amazoncognito.com",
        scope: [
          "phone",
          "email",
          "openid",
          "profile",
          "aws.cognito.signin.user.admin"
        ],
        redirectSignIn: oAuthRedirectUri,
        redirectSignOut: oAuthRedirectUri,
        responseType: "code"
      },
      apiGateway: {
        URL: "https://member-center-api.cmg.com/api/v1",
        APIKEY: process.env.REACT_APP_MC_API_KEY
      },
      sso: {
        hubOrigin: "https://membercenter-sdk.cmg.com/sdk/hub.html",
        clientOrigins: /.*/,
        tokenName: "mcRefreshToken"
      }
    };
    break;
  case "staging":
    config = {
      cognito: {
        region: "us-east-1",
        userPoolId: "us-east-1_6NvgGLCzG",
        userPoolWebClientId: "u711ui5npvoi0ko0c3po6udci"
      },
      oauthConfig: {
        domain:
          "member-center-serverless-frontend-staging.auth.us-east-1.amazoncognito.com",
        scope: [
          "phone",
          "email",
          "openid",
          "profile",
          "aws.cognito.signin.user.admin"
        ],
        redirectSignIn: oAuthRedirectUri,
        redirectSignOut: oAuthRedirectUri,
        responseType: "code"
      },
      apiGateway: {
        URL: "https://member-center-api-staging.cmg.com/api/v1",
        APIKEY: process.env.REACT_APP_MC_API_KEY
      },
      sso: {
        hubOrigin: "https://membercenter-sdk-staging.cmg.com/sdk/hub.html",
        clientOrigins: /.*/,
        tokenName: "mcRefreshToken"
      }
    };
    break;
  case "dev":
    config = {
      cognito: {
        region: "us-east-1",
        userPoolId: "us-east-1_LnneevA2V",
        userPoolWebClientId: "4tvpmrq43n1a1dqqlgcf9ds9pn",
        identityPoolId: "us-east-1:197fb68d-cbbf-4edb-bed2-61d87d302a7f"
      },
      oauthConfig: {
        domain:
          "member-center-serverless-frontend-development.auth.us-east-1.amazoncognito.com",
        scope: [
          "phone",
          "email",
          "openid",
          "profile",
          "aws.cognito.signin.user.admin"
        ],
        redirectSignIn: oAuthRedirectUri,
        redirectSignOut: oAuthRedirectUri,
        responseType: "code"
      },
      apiGateway: {
        URL: "https://member-center-api-dev.cmg-sandbox.com/api/v1",
        APIKEY: process.env.REACT_APP_MC_API_KEY
      },
      sso: {
        hubOrigin: "https://membercenter-sdk-dev.cmg-sandbox.com/sdk/hub.html",
        clientOrigins: /.*/,
        tokenName: "mcRefreshToken"
      }
    };
    break;
  case "LOCAL":
    config = {
      cognito: {
        region: "us-east-1",
        userPoolId: "us-east-1_LnneevA2V",
        userPoolWebClientId: "4tvpmrq43n1a1dqqlgcf9ds9pn",
        identityPoolId: "us-east-1:197fb68d-cbbf-4edb-bed2-61d87d302a7f"
      },
      oauthConfig: {
        domain:
          "member-center-serverless-frontend-development.auth.us-east-1.amazoncognito.com",
        scope: [
          "phone",
          "email",
          "openid",
          "profile",
          "aws.cognito.signin.user.admin"
        ],
        redirectSignIn: oAuthRedirectUri,
        redirectSignOut: oAuthRedirectUri,
        responseType: "code"
      },
      apiGateway: {
        URL: "http://localhost:3000/api/v1",
        APIKEY: "api-key-for-local-serverless-offline"
      },
      sso: {
        hubOrigin: "http://localhost:3002/dist/sdk/hub.html",
        clientOrigins: /.*/,
        tokenName: "mcRefreshToken"
      }
    };
    break;
  default:
    config = {};
    break;
}

export default config;
